// Campus photo for /colleges/university-of-maryland-college-park: CC BY-SA 4.0, by Blacktupelo, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMcKeldin_Library_Mall_University_Maryland_College_Park.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-maryland-college-park/; credited under the photo.
const photo = {
    "slug": "university-of-maryland-college-park",
    "alt": "McKeldin Library, a red brick building with a white columned portico, across the lawn of McKeldin Mall at the University of Maryland",
    "src": "/colleges/university-of-maryland-college-park/campus-1600.webp",
    "srcSmall": "/colleges/university-of-maryland-college-park/campus-800.webp",
    "srcMid": "/colleges/university-of-maryland-college-park/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-maryland-college-park/og.jpg",
    "title": "McKeldin Library Mall University Maryland College Park",
    "author": "Blacktupelo",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMcKeldin_Library_Mall_University_Maryland_College_Park.jpg",
    "read": "2026-10-01"
};

export default photo;
